import { CompRef, DocumentServicesObject } from '@wix/document-services-types';
import { EventType } from '@wix/editor-platform-sdk-types';
import { componentSelectionChangedHandler } from './componentSelectionChanged';
import { appRefreshCompleted } from './appRefreshCompleted';
import { getHostEventData } from '../../../utils/getHostEventData';

export const subscribeOnHostEvents = (
  documentServicesAPI: DocumentServicesObject,
) => {
  /**
   * In studio/responsive selection after app refresh works correctly,
   * so we do this trick for other editors or if host is not defined for some reason
   */
  // const host = window.commonConfig?.host;
  // const isEditorClassic = host === 'EDITOR' || !host;
  let shouldSkipSelectionChangedEvent = false;

  documentServicesAPI.platform.subscribeOnCustomAppEvents((e) => {
    const hostEvent = getHostEventData<{ componentRefs: CompRef[] }>(e);
    const eventType = hostEvent.eventType;

    switch (eventType) {
      case EventType.componentSelectionChanged:
        if (!hostEvent.componentRefs?.length) {
          break;
        }

        if (shouldSkipSelectionChangedEvent) {
          shouldSkipSelectionChangedEvent = false;

          return;
        }

        componentSelectionChangedHandler(documentServicesAPI, hostEvent);

        break;

      case EventType.appRefreshCompleted:
        appRefreshCompleted(documentServicesAPI);

        // if (isEditorClassic) {
        shouldSkipSelectionChangedEvent = true;
        // }

        break;
    }
  });
};
